import template from './dynamicLinkEditPage.html';
import controller from './dynamicLinkEditPage.controller';
import './dynamicLinkEditPage.scss';

let dynamicLinkEditPageComponent = {
  restrict: 'E',
  bindings: {
    dynamicLink: '='
  },
  template,
  controller
};

export default dynamicLinkEditPageComponent;
